import SpendXForDiscount from './ViewPromotion/SpendXForDiscount.vue'
import MultiBuy from './ViewPromotion/MultiBuy.vue'
import BuyXForDiscount from './ViewPromotion/BuyXForDiscount.vue'
import BuyXGetYOff from './ViewPromotion/BuyXGetYOff.vue'
export default {
  name: 'ViewPromotionPartialView',

  props: {
    value: {},
    regionId: {},
    shown: Boolean
  },

  data () {
    return {
      loading: false,
      type: null,
      promotion: null
    }
  },

  components: {
    'spend-x-for-discount': SpendXForDiscount,
    'buy-x-for-discount': BuyXForDiscount,
    'multi-buy': MultiBuy,
    'buy-x-for-y-off': BuyXGetYOff
  },

  methods: {
    reset () {
      if (this.value) {
        this.promotion = this.value
        this.type = this.value.type
        this.hide()
      }
    },

    hide () {
      this.$emit('hide')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewEvent/ViewPromotion.js